// extracted by mini-css-extract-plugin
module.exports = {"block":"UserMenu_block__PZ9Eo","more":"UserMenu_more__2GDNz"};